import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyPlanReportPageRedirectRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-redirect',
	path: '/secure/PortfolioReportView.jspa',
};
